package com.bikompanion.data

import kotlinx.serialization.Serializable

@Serializable
data class CityBikesLicenseDto(
    val name: String? = null,
    val url: String? = null,
)
